namespace Matrix.Data {
    export interface HelpTextForm {
        Topic: Serenity.StringEditor;
        NoteText: Serenity.TextAreaEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class HelpTextForm extends Serenity.PrefixedContext {
        static formKey = 'Data.HelpText';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!HelpTextForm.init)  {
                HelpTextForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(HelpTextForm, [
                    'Topic', w0,
                    'NoteText', w1,
                    'Version', w2,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3
                ]);
            }
        }
    }
}
